import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ICmsBanner } from 'banner/types/cmsBanner';

const initialState = {
  articles: [],
  assets: [],
  breadcrumbs: [],
  buttonLabel: '',
  buttonLink: '',
  collections: [],
  icon: '',
  id: null,
  pictures: [],
  productTemplates: [],
  segmentId: '',
  subsections: [],
  subtitle: '',
  title: '',
  type: 'CtaBannerSection',
  videos: [],
  xGoatSite: '',
};

const cmsBannerSlice = createSlice({
  name: 'cmsBanner',
  initialState,
  reducers: {
    setCmsBanner(state, action: PayloadAction<ICmsBanner>) {
      if (!action?.payload) {
        return;
      }
      // TODO: Remove this when we deprecate staging.goat.com
      if (
        action.payload?.title?.toLowerCase()?.includes('staging.goat.com') &&
        action.payload?.xGoatSite !== 'goat-staging'
      ) {
        return;
      }

      for (const key of Object.keys(action?.payload)) {
        if (key in state) {
          state[key] = action.payload[key];
        }
      }
    },
  },
});

export const { setCmsBanner } = cmsBannerSlice.actions;
export default cmsBannerSlice.reducer;
